import { sdkRequest } from '@eventbrite/http';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React, { useContext, useState } from 'react';
import { UserContext } from '../../context';
import { GACodes } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import Bookmark, { BookmarkProps } from './Bookmark';

type BookmarkRootProps = {
    eventId: string;
    isBookmarked: boolean;
};

const BOOKMARK_DESKTOP_ROOT_ID = 'listings-root__bookmark-desktop';
const BOOKMARK_MOBILE_ROOT_ID_ = 'listings-root__bookmark-mobile';
const BOOKMARK_REMOVE_ACTION = 'unsave';
const BOOKMARK_ADD_ACTION = 'save';

const BookmarkMobileMount = (
    bookmarkProps: BookmarkProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: Bookmark,
            containerId: BOOKMARK_MOBILE_ROOT_ID_,
        },
        bookmarkProps,
    );
};

const BookmarkDesktopMount = (
    bookmarkProps: BookmarkProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: Bookmark,
            containerId: BOOKMARK_DESKTOP_ROOT_ID,
        },
        bookmarkProps,
    );
};

const trackAnalytics = (action: string) => {
    trackAnalyticsEvent({
        action: action,
        category: GACodes.GA_CATEGORY_LISTING,
    });
};

const BookmarkRoot = (props: BookmarkRootProps): JSX.Element | null => {
    const { eventId, isBookmarked } = props;
    const [isBookmarkedEvent, setIsBookmarkedEvent] = useState(isBookmarked);
    const { isAuthenticated, id } = useContext(UserContext);
    const [isFetching, setIsFetching] = useState(false);

    const setBookmark = () => {
        const action = isBookmarkedEvent
            ? BOOKMARK_REMOVE_ACTION
            : BOOKMARK_ADD_ACTION;
        const analyticsAction = isBookmarkedEvent
            ? GACodes?.GA_ACTION_BOOKMARK_REMOVE
            : GACodes?.GA_ACTION_BOOKMARK_ADD;

        trackAnalytics(analyticsAction);
        setIsFetching(true);
        setIsBookmarkedEvent(!isBookmarkedEvent);

        sdkRequest(`/users/${id}/bookmarks/${action}/`, {
            method: 'POST',
            body: JSON.stringify({
                event_id: eventId,
            }),
        })
            .then(() => {
                // Success
            })
            .catch(() => {
                // Error
                setIsBookmarkedEvent(!isBookmarkedEvent);
            })
            .finally(() => setIsFetching(false));
    };

    const handleClick = () => {
        if (!isAuthenticated || isFetching) {
            return false;
        }
        setBookmark();
    };

    return (
        <>
            <BookmarkMobileMount
                isBookmarkedEvent={isBookmarkedEvent}
                onClick={handleClick}
            />
            <BookmarkDesktopMount
                isBookmarkedEvent={isBookmarkedEvent}
                onClick={handleClick}
            />
        </>
    );
};

export default BookmarkRoot;
